







import { createComponent, provide } from "@vue/composition-api";
import TheHeader from "@dcc/components/TheHeader.vue";
import { dictionary } from "@dcc/lookup/dictionary/dictionary";
const dictionarySymbol = Symbol();

export default createComponent({
  components: {
    TheHeader
  },
  setup() {
    provide(dictionarySymbol, dictionary);
    return {};
  }
});
